import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setIsMenuOpen(false);
        }
    };

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="container header-content">
                <div className="logo" onClick={() => scrollToSection('hero')}>
                    BAR BEN ABU
                </div>

                <nav className={`desktop-nav ${isMenuOpen ? 'open' : ''}`}>
                    <button onClick={() => scrollToSection('about')}>אודות</button>
                    <button onClick={() => scrollToSection('services')}>שירותים</button>
                    <button onClick={() => scrollToSection('projects')}>פרויקטים</button>
                    <button onClick={() => scrollToSection('process')}>תהליך</button>
                    <button onClick={() => scrollToSection('contact')} className="cta-button-small">צור קשר</button>
                </nav>

                <button className="mobile-menu-btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {isMenuOpen && (
                <div className="mobile-nav">
                    <button onClick={() => scrollToSection('about')}>אודות</button>
                    <button onClick={() => scrollToSection('services')}>שירותים</button>
                    <button onClick={() => scrollToSection('projects')}>פרויקטים</button>
                    <button onClick={() => scrollToSection('process')}>תהליך</button>
                    <button onClick={() => scrollToSection('contact')}>צור קשר</button>
                </div>
            )}
        </header>
    );
};

export default Header;
